import React, { useContext, useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';
import ParticipateItem from '../components/ParticipateItem';
import ParticipateItem2 from '../components/ParticipateItem2';
import MyParticipateWaysContext from '../context/ParticipateWaysContext';
import Pager from '../components/Pager.js';
import Loading from '../components/Loading.js';

const Participa = () => {
    const { useParticipateWays, maxPage, setPage, page } = useContext(MyParticipateWaysContext);
    const { participateWays, isError, isLoading } = useParticipateWays();

    useDocumentTitle("Participa");

    return (
        <div>
            <PageHeader tittle="PARTICIPA" />
            <div className=" mx-auto my-4">
                <Loading isLoading={isLoading} />
                {participateWays && participateWays.length > 0 ? participateWays.map((participateWay, index) => (
                    index % 2 == 0 ? <ParticipateItem key={index} participateWay={participateWay} number={index} /> : <ParticipateItem2 key={index} participateWay={participateWay} number={index} />
                )) : <div className='py-8 mx-auto px-4 max-w-screen-md border-b-2 border-gray-600'><p className="font-light text-center text-xl">Consulte aquí la información relacionada a los espacios de participación ciudadana en las decisiones y acciones públicas.</p></div>}
                {isError ? <h1 className='text-center text-red-400 w-full mb-4'>Ha ocurrido un error al cargar la información.</h1> : null}
                {maxPage < 1 ? null : <div className='flex justify-center'>
                    <Pager maxPage={maxPage} setPage={setPage} />
                </div>}
            </div>
        </div>
    );
}

export default Participa;